<template>
  <div class="content">
    <div class="question-type" @click="showQuestion = true">
      <p>
        我的提问类型:
        <span style="color: #4fd9d5" v-show="questiontext"
          >【{{ questiontext }}】</span
        >
      </p>
      <i class="iconfont icon-a-LeftArrow"></i>
    </div>

    <div class="select-question" v-show="questionlist.length">
      <div class="select-question-head">
        <span>您可能会遇到的问题：</span>
        <div v-show="showChangeIt" @click="changeIt">换一换</div>
      </div>

      <div class="select-question-q">
        <ul>
          <li
            v-for="(item, index) in questionlist"
            :key="index"
            @click="slectQustion(item)"
          >
            <div :class="item.checked ? 'radio-checked' : 'radio-q'"></div>
            <p>{{ index + 1 }}、{{ item.title }}</p>
          </li>
        </ul>
        <div class="select-tips">
          <p>
            没有找到想要的问题？
            <span @click="showcustom = !showcustom">点我自定义提问~</span>
          </p>
        </div>
      </div>
    </div>

    <div class="select-question" v-show="showcustom">
      <div class="select-question-head">
        <span>自定义提问内容</span>
      </div>
      <div class="textarea">
        <textarea
          placeholder="请详细描述你的问题，背景信息以及具体问题"
          name=""
          id=""
          v-model="customtext"
        ></textarea>
      </div>
      <div class="select-question-q">
        <div
          class="select-tips"
          style="
            margin: 0;
            font-size: 12px;
            white-space: nowrap;
            transform: scale(0.9);
            color: #666666;
          "
        >
          <p>提示：仅限提出单个问题，多个问题老师会选择其中一个问题作答！</p>
        </div>
      </div>
    </div>

    <div class="input-box">
      <span>姓名</span>
      <input v-model="name" type="text" placeholder="请输入真实姓名" />
    </div>

    <div class="sex">
      <div :class="{ action: sex == 1 }" @click="sex = 1">男</div>
      <div :class="{ action: sex == 0 }" @click="sex = 0">女</div>
    </div>

    <div class="select-time">
      <span>出生日期：</span>
      <div class="select-box" @click="showdate = true">
        <span>{{ date }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
    </div>
    <div class="select-time">
      <span>出生时辰：</span>
      <div class="select-box" @click="showtime = true">
        <span>{{ time }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
    </div>

    <div class="r-number">
      <span>随机填写3个0-9的数字：</span>
      <div>
        <input v-model="input1" type="number" />
        <input v-model="input2" type="number" />
        <input v-model="input3" type="number" />
      </div>
    </div>

    <div class="next-step" @click="nextStep">下一步</div>
    <popup
      v-model="showQuestion"
      round
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="popup-title">选择提问类型</div>
      <div class="questions">
        <div
          v-for="(item, index) in questiontypes"
          :key="index"
          :class="{ action: item.checked }"
          @click="switchQuestion(item)"
        >
          {{ item.title }}
        </div>
      </div>
    </popup>
    <select-date
      v-model="showdate"
      :lunar="lunar"
      @confirm="dateConfirm"
      :date="date"
    />

    <select-time v-model="showtime" :date="time" @confirm="timeConfirm" />
  </div>
</template>

<script>
/**
@description:我要提问
@createTime:2021-08-23
@create:wq
*/
import selectDate from "@/components/selectDate.vue";
import selectTime from "@/components/selectTime.vue";
import { Popup } from "vant";
export default {
  name: "",
  props: {},
  components: { selectDate, selectTime, Popup },
  data() {
    return {
      number: "",
      name: "",
      sex: 1,
      input1: "",
      input2: "",
      input3: "",
      showQuestion: false,
      questiontypes: [],
      questiontext: "",
      questionlist: [],
      showcustom: false,
      showChangeIt: false,
      customtext: "",
      showdate: false,
      showtime: false,
      lunar: 0,
      date: "请选择出生年月日",
      time: "请选择出生时辰",
    };
  },
  watch: {
    input1() {
      if (this.input1.length > 1) this.input1 = this.input1.slice(0, 1);
    },
    input2() {
      if (this.input2.length > 1) this.input2 = this.input2.slice(0, 1);
    },
    input3() {
      if (this.input3.length > 1) this.input3 = this.input3.slice(0, 1);
    },
    customtext(value) {
      if (value) {
        this.questionlist.forEach((o) => (o.checked = false));
      }
    },
  },
  mounted() {},
  created() {
    this.problemCate();
  },
  methods: {
    nextStep() {
      if (!this.questiontypes.some((o) => o.checked)) {
        return this.Toast("请选择问题类型");
      }
      if (!(this.questionlist.some((o) => o.checked) || this.customtext)) {
        return this.Toast("请选择问题");
      }

      if (!this.name) {
        return this.Toast("请填写名字");
      }
      if (this.date === "请选择出生年月日") {
        return this.Toast("请选择出生年月日");
      }
      if (this.time === "请选择出生时辰") {
        return this.Toast("请选择出生时辰");
      }
      if (!(this.input1 && this.input2 && this.input3)) {
        return this.Toast("请填写完整随机数字");
      }
      // console.log(this.questiontypes.find((o) => o.checked));
      let c = this.questiontypes.find((o) => o.checked);
      const obj = {
        name: this.name,
        type: 2,
        id: this.questionlist.find((o) => o.checked),
        answers: this.customtext,
        pcid: this.questiontypes.find((o) => o.checked),
        sex: this.sex,
        birthday: this.date,
        lunar: this.lunar,
        time: this.time,
        num: `${this.input1},${this.input2},${this.input3}`,
      };
      localStorage.setItem("order", JSON.stringify(obj));
      // console.log(this.questiontypes);
      // return
      this.$router.push({
        path: "/st",
        query: { p: c.price, num: c.num },
      });
    },
    problemCate() {
      this.api.problemCate().then((res) => {
        console.log(res);
        this.questiontypes = res.data;
      });
    },
    problemList(pid) {
      this.api.problemList({ pid }).then((res) => {
        this.questionlist = res.data.data;
        if (res.data.num > 5) {
          setTimeout(() => {
            this.showChangeIt = true;
          }, 1000);
        } else {
          this.showChangeIt = false;
        }
      });
    },
    switchQuestion(item) {
      this.questiontypes.forEach((o) => (o.checked = false));
      item.checked = true;
      this.questiontext = item.title;
      this.showQuestion = false;
      this.problemList(item.id);
      this.$forceUpdate();
    },
    slectQustion(item) {
      this.customtext = "";
      this.questionlist.forEach((o) => (o.checked = false));
      item.checked = true;
      this.$forceUpdate();
    },
    dateConfirm(data) {
      this.lunar = data.lunar;
      this.date = data.date;
    },
    timeConfirm(data) {
      this.time = data.date;
    },
    changeIt() {
      this.showChangeIt = false;
      const id = this.questiontypes.find((o) => o.checked).id;
      this.problemList(id);
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
}
.question-type {
  margin: 0.22rem 0 0.42rem;
  height: 0.8rem;
  border-radius: 0.2rem;
  padding: 0 0.34rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 0.3rem;
  font-weight: 400;
  color: #333333;
  background: rgba($color: #4fd9d5, $alpha: 0.1);
  border: 1px solid #4fd9d5;
  i {
    font-size: 12px;
    color: #cccccc;
  }
}

.select-question {
  background: #f5f5f5;
  border: 1px solid #e6e6e6;
  border-radius: 0.2rem;
  margin-bottom: 0.32rem;
  .select-question-head {
    height: 0.76rem;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.32rem;
    > span {
      font-size: 0.24rem;
      font-weight: 400;
      color: #666666;
    }
    > div {
      font-size: 12px;
      color: #ffffff;
      background: #4fd9d5;
      border-radius: 20px;
      padding: 4px 10px;
    }
  }
  .select-question-q {
    ul {
      margin: 0.2rem 0.16rem;
      li {
        margin-bottom: 0.12rem;
        height: 0.82rem;
        background: #ffffff;
        border-radius: 0.2rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #666666;
        padding-left: 0.26rem;
        display: flex;
        align-items: center;
        .radio-q {
          width: 0.32rem;
          height: 0.32rem;
          background: #f5f5f5;
          border: 1px solid #e6e6e6;
          border-radius: 50%;
          margin-right: 0.18rem;
          flex-shrink: 0;
        }
        .radio-checked {
          width: 0.32rem;
          height: 0.32rem;
          background: #4fd9d5;
          border: 1px solid #aaefed;
          border-radius: 50%;
          margin-right: 0.18rem;
          flex-shrink: 0;
        }
      }
    }
    .select-tips {
      font-size: 0.24rem;
      font-weight: 400;
      margin-left: 0.34rem;
      margin-top: 0.62rem;
      margin-bottom: 0.2rem;
      span {
        color: #4fd9d5;
      }
    }
  }
  .textarea {
    margin: 0.16rem;
    margin-bottom: 0;
    textarea {
      border-radius: 5px;
      height: 100px;
      width: 100%;
      border: none;
      padding: 10px;
      box-sizing: border-box;
      resize: none;
      font-size: 0.28rem;
    }
  }
}

.input-box {
  padding: 0 0.34rem;
  height: 0.8rem;
  box-sizing: border-box;

  background: #f5f5f5;
  border: 1px solid #e6e6e6;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  span {
    margin-right: 1.64rem;
    white-space: nowrap;
  }
  input {
    flex: 1;
    height: 100%;
    border: none;
    background: transparent;
  }
}
.sex {
  //   padding: 0 0.34rem;
  margin: 0.32rem 0;
  height: 0.8rem;
  border-radius: 0.4rem;
  box-sizing: border-box;
  background: #f0f0f0;
  overflow: hidden;

  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .action {
    color: #ffffff;
    background: #4fd9d5;
  }
}

.select-time {
  margin: 0.26rem 0;
  display: flex;
  align-items: center;
  > span {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
  }
  .select-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.24rem 0 0.44rem;
    border-radius: 0.5rem;
    background: #f0f0f0;
    border: 1px solid #e6e6e6;
    height: 0.76rem;
    span {
      font-size: 0.26rem;
      font-weight: 500;
      color: #333333;
    }
    i {
      font-size: 0.28rem;
      color: #53cedc;
    }
  }
}

.r-number {
  display: flex;
  align-items: center;
  > span {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
  }
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    input {
      width: 0.72rem;
      height: 0.72rem;
      background: #f0f0f0;
      border: 1px solid #e6e6e6;
      margin-right: 0.16rem;
      text-align: center;
    }
  }
}
.next-step {
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 0.88rem;
  margin-top: 0.84rem;
}
.popup-title {
  font-size: 0.32rem;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin: 0.4rem 0;
}
.questions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  > div {
    width: 1.6rem;
    height: 0.7rem;
    background: #f8f8f8;
    border: 1px solid #e3e3e3;
    border-radius: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.28rem;
    color: #666666;
    margin-bottom: 0.25rem;
  }
  .action {
    color: #ffffff;
    border-color: #34c290;
    background: #34c290;
  }
}
</style>
